import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuIta = () => {
  const [isOpen, setIsOpen] = useState(false)
          
  const toggle = () => {
  setIsOpen(!isOpen)
  }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            EXKLUSIVA ANTIPASTI
                        </div><br /><br />
                        <div className='menu_mat'>
                            Burrata Pugliese med San Marzano-tomater, basilika & extra virgin olivolja.
                            <br /><br />
                            Vitello Tonnato med kapris, citron & parmesan.
                            <br /><br />
                            Prosciutto di Parma 24 månader.
                            <br /><br />
                            Bresaola della Valtellina med ruccola, parmesan & citron.
                            <br /><br />
                            Mortadella Bologna med pistage.
                            <br /><br />
                            Carpaccio di Manzo med parmesan, ruccola & citron.
                            <br /><br />
                            Marinerade kronärtskockor.
                            <br /><br />
                            Grillad aubergine, zucchini & paprika med vitlök och olivolja.
                            <br /><br />
                            Soltorkade tomater.
                            <br /><br />
                            Italienska oliver.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            LYXIG OSTBRICKA
                      </div><br /><br />
                      <div className='menu_mat'>
                        Parmigiano Reggiano.
                        <br /><br />
                        Pecorino Romano.
                        <br /><br />
                        Gorgonzola Dolce.
                        <br /><br />
                        Taleggio.
                        <br /><br />
                        Fikon, päron & vindruvor.
                        <br /><br />
                        Italiensk honung.
                        <br /><br />
                        Fikonmarmelad.
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                        FRÄSCHA ITALIENSKA SALLADER
                        </div><br /><br />
                    <div className='menu_mat'>
                        Caprese med buffelmozzarella, tomat & basilika.
                        <br /><br />
                        Ruccola, päron, parmesan & balsamico.
                        <br /><br />
                        Fänkål, apelsin & mynta.
                        <br /><br />
                        Italiensk potatissallad med kapris, persilja & olivolja.
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        BRÖD & TILLBEHÖR
                        </div><br /><br />
                        <div className='menu_mat'>
                            Focaccia med rosmarin & havssalt.
                            <br /><br />
                            Ciabatta.
                            <br /><br />
                            Grissini.
                            <br /><br />
                            Pane carasau.
                            <br /><br />
                            Extra virgin olivolja.
                            <br /><br />
                            Balsamico di Modena.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            KALLA PASTARÄTTER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Pasta Pesto Genovese med basilika, pinjenötter & parmesan.
                            <br /><br />
                            Pasta med soltorkade tomater, mozzarella, ruccola & olivolja.
                            <br /><br />
                            Orzo med grillade grönsaker, citron & färska örter.
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                DESSERT
                            </div><br /><br />
                        <div className='menu_mat'>                   
                            Tiramisù Classico.
                            <br /><br />
                            Panna cotta med vanilj & färska bär.
                            <br /><br />
                            Cannoli Siciliani.
                            <br /><br />
                            Italienska mandelkakor.
                        </div>
                        </div> 
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuIta